import {actionTypes} from "./actionTypes";
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const get4DCollections=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_4D_COLLECTIONS_START
    });
    const options={
        url:`${api}/fourDCollections`,
        method:'GET',
        headers:{
            Authorization:`Bearer ${token}`
        }
    }
    await axios(options)
        .then(response=>dispatch({
            type:actionTypes.GET_4D_COLLECTIONS_SUCCESS,
            payload:response.data
        }))
        .catch(error=>dispatch({
            type:actionTypes.GET_4D_COLLECTIONS_FAIL,
            payload:getMessage(error)
        }))
}